(()=>{
  const root=document.querySelector('[data-fm-promo-line]');
  if(!root)return;
  const url=root.dataset.lineUrl||'';
  if(!url)return;

  const popup=root.querySelector('[data-fm-line-popup]');
  const closePopup=()=>{
    if(!popup)return;
    popup.hidden=true;
    try{sessionStorage.setItem('fm-line-popup-seen','1')}catch(error){}
  };

  if(popup){
    root.querySelectorAll('[data-fm-line-close]').forEach(button=>button.addEventListener('click',closePopup));
    popup.addEventListener('click',event=>{if(event.target===popup)closePopup()});
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!popup.hidden)closePopup()});
    let seen=false;
    try{seen=sessionStorage.getItem('fm-line-popup-seen')==='1'}catch(error){}
    const force=new URLSearchParams(location.search).get('preview_line')==='1';
    if((force||(!seen&&!window.Shopify?.designMode))&&root.dataset.popupEnabled==='true'){
      window.setTimeout(()=>{popup.hidden=false;popup.querySelector('a,button')?.focus()},Number(root.dataset.popupDelay)||2500);
    }
  }

  if(root.dataset.bandEnabled==='true'){
    const footer=document.querySelector('.footer,.fm-pdp__footer,footer');
    const template=root.querySelector('[data-fm-line-band-template]');
    if(footer&&template)footer.before(template.content.cloneNode(true));
  }

  if(root.dataset.footerEnabled==='true'){
    const target=document.querySelector('.footer-bottom .footer-links,.fm-pdp__footer-links,footer .list-social,footer');
    const template=root.querySelector('[data-fm-line-footer-template]');
    if(target&&template)target.append(template.content.cloneNode(true));
  }
})();
